import { isUploadImageCropShapeCircle } from '../UploadImage.utils'

export function getUploadImageStageImageHostStyle({ layout, rotation }) {
  return {
    height: layout.elementHeight,
    left: layout.elementLeft,
    top: layout.elementTop,
    transform: `rotate(${-rotation}deg)`,
    width: layout.elementWidth,
  }
}

export function getUploadImageStageCropStyle(crop) {
  return {
    height: crop.height,
    left: crop.x,
    top: crop.y,
    width: crop.width,
  }
}

export function getUploadImageStageMaskStyle({ crop, cropShape }) {
  return {
    ...getUploadImageStageCropStyle(crop),
    borderRadius: isUploadImageCropShapeCircle(cropShape) ? '50%' : 0,
  }
}
